import { StepId } from '../../api/useRiskToleranceWorkflowQuery';
import AccumulationSVG from './img/accumulation.svg';
import MaintenanceSVG from './img/maintenance.svg';
import DistributionSVG from './img/distribution.svg';

export interface FormValues {
  [StepId.InvestmentObjective]: number;
}

export const title = 'Which of the following best describes your primary objective?';

export const options = [
  {
    label: 'Accumulation',
    description:
      'Emphasis on continued capital appreciation in accordance with your overall risk tolerance',
    value: 1,
    Illustration: AccumulationSVG,
  },
  {
    label: 'Maintenance',
    description: 'Emphasis on maintaining a desired lifestyle or level of financial security',
    value: 2,
    Illustration: MaintenanceSVG,
  },
  {
    label: 'Distribution',
    description: 'Emphasis on using wealth for living expenses',
    value: 3,
    Illustration: DistributionSVG,
  },
];
